class DynamicYield {

	selectors = [
		'article.en_mdl_product[data-slot-id]',
		'article.mdl_productcarousel_item[data-slot-id]',
		'.mdl_search__suggestions-product[data-slot-id]',
	];

	constructor() {
		// Add Click Listener.
		document.addEventListener( 'click', ( ev ) => {
			const targetEl = ev.target.closest( this.selectors.join( ', ' ) );
			if ( targetEl ) {
				this.reportEngagement( targetEl );
			}
		} );
	}

	/**
	 * Dynamic Yield Tracking - Report Engagement.
	 */
	reportEngagement( targetEl ) {
		if ( 'function' === typeof navigator.sendBeacon ) {

			// Endpoint.
			const url = '/index.php?cl=dynamic_yield_api&fnc=reportEngagement';

			// Setup Postdata.
			const postData = new FormData();
			postData.append( 'type', 'SLOT_CLICK' );
			postData.append( 'slotId', targetEl.getAttribute( 'data-slot-id' ) );

			if ( targetEl.dataset.variations ) {
				const variations = String( targetEl.dataset.variations ).split( ',' ) || [];
				variations.map( variation => {
					postData.append( 'variations[]', variation );
				} );
			}

			// Report Engagement to Beacon.
			return navigator.sendBeacon( url, postData );
		}

		return false;
	}
}

const initDynamicYield = () => {
	window.SL_DY_TRACKING ??= new DynamicYield();
	return window.SL_DY_TRACKING;
}

export {
	DynamicYield as default,
	initDynamicYield
}
